import UploadInfoModal from './UploadInfoModal';

export default UploadInfoModal;


// WEBPACK FOOTER //
// ./src/components/UploadInfoModal/index.jsx